import api from '../api'

export const fetchNotification = () => {
  return api.get('/notifications ')
}

export const fetchNotificationPreferences = (params = {}) => {
  return api.get('/farm_user_notification_preferences', {
    params: {
      'farmUser.farm': atob(window.localStorage.getItem('farm-id')),
      'farmUser.user': atob(window.localStorage.getItem('user-id'))
    }
  })
}

export const fetchNotificationCategories = (params = {}) => {
  return api.get('/notification_categories', { params: { ...params } })
}

export const fetchPlateReady = (params = {}) => {
  return api.get('/notifications/plate_barcode_ready', {
    params: {
      ...params,
      farm: atob(window.localStorage.getItem('farm-id')),
      user: atob(window.localStorage.getItem('user-id'))
    }
  })
}

export const fetchBillsCloseExpiration = (params = {}) => {
  return api.get('/notifications/bills_close_expiration', {
    params: {
      farm: atob(window.localStorage.getItem('farm-id')),
      user: atob(window.localStorage.getItem('user-id')),
      category: 2
    }
  })
}

export const fetchBillsExpiration = (params = {}) => {
  return api.get('/notifications/bills_expiration', {
    params: {
      farm: atob(window.localStorage.getItem('farm-id')),
      user: atob(window.localStorage.getItem('user-id')),
      category: 3
    }
  })
}

export const fetchClinicalCure = (params = {}) => {
  return api.get('/notifications/diagnostics_clinical_cure', {
    params: {
      farm: atob(window.localStorage.getItem('farm-id')),
      user: atob(window.localStorage.getItem('user-id')),
      category: 5
    }
  })
}

export const createNotificationPreferences = (body) => {
  return api.post('/farm_user_notification_preferences', body)
}

export const updateNotificationPreferences = (id, body) => {
  return api.put(`/farm_user_notification_preferences/${id}`, body)
}
